export default __webpack_public_path__ + "static/media/figuremap59.0b89b7fe.png";